import styled from "@emotion/styled"

export const HiddenInput = styled.input({
  display: "none",
})
